<template>
  <div
    class="document"
    :style="
      document.properties && document.properties.style
        ? document.properties.style
        : {}
    "
  >
    <!-- <y-showcase
      :data="{ content: document.content }"
      v-if="document.format == 'HTML'"
    ></y-showcase> -->
    <div v-if="document.format === 'RICH_TEXT'" v-html="document.content"></div>
    <div v-else-if="document.format === 'PDF'">
      <vue-pdf
        :src="document.url"
        v-for="i in pdf.totalPage"
        :key="i"
        :page="i"
      ></vue-pdf>
    </div>
  </div>
</template>
<script>
import VuePdf from "vue-pdf";
import { get } from "../../http/http";
export default {
  components: {
    "vue-pdf": VuePdf,
  },
  data() {
    return {
      loading: false,
      document: {},
      pdf: {
        totalPage: 0,
      },
    };
  },
  methods: {
    async getDocument(document) {
      this.document = await get(`/web/document/${document.id}`);

      if (this.document.format === "PDF") {
        const pdf = await VuePdf.createLoadingTask(this.document.url).promise;
        this.pdf.totalPage = pdf.numPages;
      }
    },
  },
  watch: {
    "$route.params.id": {
      immediate: true,
      async handler(newId) {
        this.document = { id: newId };
        await this.getDocument(this.document);
      },
    },
  },
};
</script>

<style lang="less" scoped>
.document {
  background: #fff;
  margin: 16px auto !important;
  padding: 16px;
  width: 66%;
}
</style>



// WEBPACK FOOTER //
// src/view/document/_id.vue